import React from 'react';
import { Calculator } from 'lucide-react';
import { PriceBreakdownWrapper } from './PriceBreakdownWrapper';

interface UtilitiesBreakdownProps {
  priceItems: any[];
  currency: string;
  eurPrices?: any[];
}

export function UtilitiesBreakdown({ priceItems, currency, eurPrices }: UtilitiesBreakdownProps) {
  const UTILITIES_ITEMS = [
    { id: 30, name: 'Charges mensuelles (électricité, chauffage, eau) - 85m²' },
    { id: 33, name: 'Internet (60 Mbps+, illimité)' },
    { id: 34, name: 'Forfait mobile (appels + 10GB data)' }
  ];

  const getItemPrice = (itemId: number) => {
    const item = priceItems.find(item => item.item_id === itemId);
    const eurItem = eurPrices?.find(item => item.item_id === itemId);
    
    if (!item) return null;

    return {
      price: item.average_price,
      eurPrice: eurItem?.average_price
    };
  };

  return (
    <PriceBreakdownWrapper title="Prix moyens constatés pour vous aider à estimer votre budget">
      <div className="space-y-2">
        {UTILITIES_ITEMS.map(item => {
          const prices = getItemPrice(item.id);
          if (!prices) return null;

          return (
            <div key={item.id} className="flex flex-col sm:flex-row sm:items-center sm:justify-between py-2 border-b border-gray-200/50 dark:border-gray-700/50 last:border-0">
              <span className="text-sm text-gray-600 dark:text-gray-400 mb-1 sm:mb-0">
                {item.name}
              </span>
              <div className="text-right font-mono text-base sm:text-sm font-medium text-primary-600 dark:text-primary-400">
                {(prices.eurPrice || prices.price).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
              </div>
            </div>
          );
        })}

        {/* Notes */}
        <div className="mt-6 pt-4 border-t-2 border-gray-200 dark:border-gray-600">
          <div className="flex items-start gap-3">
            <Calculator className="hidden sm:block w-4 h-4 flex-shrink-0 mt-0.5 text-gray-400 dark:text-gray-500" />
            <p className="text-xs text-gray-500 dark:text-gray-400 leading-relaxed">
              Les charges sont calculées proportionnellement au type de logement choisi. Par exemple, un studio consommera moins qu'un grand appartement. Les montants peuvent varier selon la saison et la zone géographique. Certains logements incluent les charges dans le loyer.
            </p>
          </div>
        </div>
      </div>
    </PriceBreakdownWrapper>
  );
}